module.exports = __webpack_public_path__ + "img/gas.517a59f9.png";